import React, { useEffect, useState } from 'react'
import { Card, CardBody, Badge, Container, Alert, Row, Col, Button } from 'reactstrap'
import ReactMarkdown from 'react-markdown'
import { withTranslation } from 'react-i18next'
import ChangelogRepository from './repository/changelog-repository'
import LoadingContainer from '../Utility/Helpers/LoadingContainer'
import '../Utility/Helpers/style.css'

const PagesChangelog = (props) => {
  const [changelog, setChangelog] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showAll, setShowAll] = useState(false)

  useEffect(() => {
    loadChangelog()
  }, [props.i18n.language])

  const loadChangelog = () => {
    setLoading(true)
    setError(null)

    const currentLang = props.i18n.language || 'en'

    ChangelogRepository.getChangelog(currentLang)
      .then(data => {
        setChangelog(data)
        setLoading(false)
      })
      .catch(err => {
        setError(props.t('ERROR_OCCURRED'))
        setLoading(false)
      })
  }

  const renderSection = (title, items, icon, color) => {
    if (!items || items.length === 0) return null

    return (
      <div className="mb-4">
        <h4 className={`text-${color} fs-5`}>
          {icon} {title}
        </h4>
        <ul className="fs-6">
          {items.map((item, index) => (
            <li key={index} className="mb-2">
              <ReactMarkdown>{item}</ReactMarkdown>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <>
      <div className="page-content">
        <title>{props.t('CHANGELOG')}</title>
        <Container fluid>
          <LoadingContainer loading={loading}>
            {error && (
              <Alert color="danger" className="mb-4">
                {error}
              </Alert>
            )}

            {changelog && changelog.latest && (
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <h2 className="mb-3 fs-3">
                            {props.t('WHATS_NEW')}
                            {changelog.latest.isUnreleased && (
                              <Badge color="success" className="ms-2 fs-6">
                                {props.t('UNRELEASED')}
                              </Badge>
                            )}
                          </h2>
                          <h4 className="text-muted mb-2 fs-5">
                            {props.t('VERSION')}: {changelog.latest.version}
                          </h4>
                          <p className="text-muted mb-0 fs-6">
                            {props.t('LAST_UPDATE')}: {new Date(changelog.latest.date).toLocaleDateString(props.i18n.language)}
                          </p>
                        </div>
                        <Button
                          color="primary"
                          outline
                          onClick={() => setShowAll(!showAll)}
                          className="fs-6"
                        >
                          {showAll ? props.t('SHOW_LATEST_ONLY') : props.t('SHOW_ALL_VERSIONS')}
                        </Button>
                      </div>

                      <hr />

                      {!showAll ? (
                        <div className="fs-6">
                          {renderSection(
                            props.t('ADDED'),
                            changelog.latest.added,
                            '✨',
                            'success'
                          )}
                          {renderSection(
                            props.t('CHANGED'),
                            changelog.latest.changed,
                            '🔄',
                            'warning'
                          )}
                          {renderSection(
                            props.t('FIXED'),
                            changelog.latest.fixed,
                            '🐛',
                            'danger'
                          )}
                          {renderSection(
                            props.t('REFACTORED'),
                            changelog.latest.refactored,
                            '♻️',
                            'info'
                          )}
                          {renderSection(
                            props.t('DEPRECATED'),
                            changelog.latest.deprecated,
                            '⚠️',
                            'warning'
                          )}
                          {renderSection(
                            props.t('REMOVED'),
                            changelog.latest.removed,
                            '🗑️',
                            'secondary'
                          )}
                          {renderSection(
                            props.t('SECURITY'),
                            changelog.latest.security,
                            '🔒',
                            'danger'
                          )}
                          {renderSection(
                            props.t('TECHNICAL_DETAILS'),
                            changelog.latest.technical,
                            '🔧',
                            'secondary'
                          )}
                        </div>
                      ) : (
                        <div className="changelog-content fs-6">
                          <ReactMarkdown>{changelog.rawContent}</ReactMarkdown>
                        </div>
                      )}

                      <hr className="mt-4" />
                      <div className="text-muted small fs-6">
                        <p className="mb-0">
                          {props.t('LANGUAGE')}: {changelog.language.toUpperCase()} | 
                          {' '}{props.t('LAST_FILE_UPDATE')}: {new Date(changelog.lastModified).toLocaleString(props.i18n.language)}
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </LoadingContainer>
        </Container>
      </div>
    </>
  )
}

export default withTranslation()(PagesChangelog)
